import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Shield, AlertCircle, Loader2, Lock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/login`, {
        username: username.trim().toLowerCase(),
        password
      });

      if (response.data.success) {
        localStorage.setItem('admin_token', response.data.token);
        localStorage.setItem('admin_username', response.data.username || '');
        localStorage.setItem('admin_name', response.data.name || '');
        localStorage.removeItem('admin_email');
        navigate('/nrv-panel');
      }
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-slate-800 border-slate-700">
        <CardHeader className="text-center">
          <div className="w-16 h-16 bg-indigo-600 rounded-xl flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <CardTitle className="text-2xl text-white" style={{ fontFamily: 'Manrope' }}>Admin Panel</CardTitle>
          <p className="text-sm text-slate-500 mt-1 dark:text-zinc-400">Nerava Administration</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            {error && (
              <div
                data-testid="admin-login-error"
                className="flex items-center gap-2 p-3 rounded-lg bg-red-900/30 border border-red-800 text-red-400 text-sm"
              >
                <AlertCircle className="w-4 h-4 shrink-0" />
                {error}
              </div>
            )}

            <div>
              <Label className="text-slate-300">Username / ID</Label>
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="mt-1 bg-slate-700 border-slate-600 text-white"
                placeholder="username admin"
                autoComplete="username"
                autoCapitalize="none"
                spellCheck={false}
                required
                data-testid="admin-username"
              />
            </div>

            <div>
              <Label className="text-slate-300">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 bg-slate-700 border-slate-600 text-white"
                placeholder="••••••••"
                autoComplete="current-password"
                required
                data-testid="admin-password"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-indigo-600 hover:bg-indigo-700 gap-2"
              data-testid="admin-login-btn"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
              {loading ? 'Authenticating...' : 'Login to Admin'}
            </Button>
          </form>

          <div className="mt-6 p-3 rounded-lg bg-slate-700/50 border border-slate-600">
            <p className="text-xs text-slate-500 flex items-center gap-1.5 dark:text-zinc-400">
              <Shield className="w-3.5 h-3.5" />
              Login admin memakai username, bukan email. Sesi berakhir setelah 8 jam. Maksimal 5 percobaan.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
